import styled from 'styled-components';

export const LinkWrapper = styled.div`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const TableWrapper = styled.div`
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background: ${({ theme }) => theme.colors.green1} !important;
  }
`;
